
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SlideableMixin extends Vue {
  @Prop() public elementCount!: number;
  @Prop() public perSlide!: number;
  @Prop() public refName!: string;
  public showUp: boolean = false;
  public showDown: boolean = this.elementCount > this.perSlide + 0.5;

  public scrollToTop() {
    this.slider.slideTo(0);
    this.onSlideChangeEnd();
  }
  public updated() {
    this.onSlideChangeEnd();
  }
  // noinspection JSUnusedLocalSymbols
  public scrollUp() {
    this.slider.slidePrev();
  }
  // noinspection JSUnusedLocalSymbols
  public scrollDown() {
    this.slider.slideNext();
  }

  // noinspection JSUnusedLocalSymbols
  public onSlideChangeEnd() {
    if (this.slider === undefined) {
      return;
    }
    this.showUp = !this.isFirstPage();
    this.showDown = !this.isLastPage() && this.slider.slidesCount > this.slider._props.itemsToShow;
    if (this.getVirtualPage() > this.slider.slidesCount - this.slider._props.itemsToShow) {
      this.slider.slideTo(this.elementCount - this.perSlide);
    }
  }
  private get slider() {
    return this.$refs[this.refName] as any;
  }
  public isFirstPage(): boolean {
    return this.getVirtualPage() === 0;
  }

  public isLastPage(): boolean {
    return this.getVirtualPage() === this.slider.slidesCount - this.slider._props.itemsToShow;
  }

  public getVirtualPage(): number {
    return this.slider.currentSlide;
  }
}
